const AnalyticsTab: React.FC = () => {
  return (
    <div className="rounded-xl border bg-white p-6">
      <h2 className="text-xl font-semibold">Analytics</h2>
      <p className="mt-2 text-gray-500">
        Deep insights & analytics will appear here.
      </p>
    </div>
  );
};

export default AnalyticsTab;
